import { QueryFunctionContext, QueryKey, useQueries } from '@tanstack/react-query';
import { Loop54Types } from '~/lib/data-contract';
import { getSearch, getSearchAutocomplete } from '~/services/loop54/operations';
import { getBrand } from '~/services/shop/operations';
import { searchOptions } from './useSearch';

export default function useSearchAutocomplete(query: string | undefined) {
    const searchQuery: Loop54Types.SearchRequest = {
        query: query ?? '',
        customData: {
            directSearch: true,
        },
        resultsOptions: {
            filter: { type: 'type', value: 'Product' },
            sortBy: [{ type: 'relevance' }],
            take: 4,
        },
    };

    const searchAutocompleteQuery: Loop54Types.AutoCompleteRequest = {
        query: query ?? '',
        customData: {
            directSearch: true,
        },
        queriesOptions: {
            take: 3,
        },
    };

    return useQueries({
        queries: [
            {
                queryKey: ['searchAutocomplete', searchQuery],
                queryFn: ({ signal }: QueryFunctionContext<QueryKey, any>) =>
                    getSearch(signal, searchQuery),
                enabled: !!query,
                retry: false,
                ...searchOptions,
            },
            {
                queryKey: ['brand', query],
                queryFn: ({ signal }: QueryFunctionContext<QueryKey, any>) =>
                    getBrand(signal, undefined, query),
                enabled: !!query,
                retry: false,
            },
            {
                queryKey: ['searchAutocompleteSuggestions', searchAutocompleteQuery],
                queryFn: ({ signal }: QueryFunctionContext<QueryKey, any>) =>
                    getSearchAutocomplete(signal, searchAutocompleteQuery),
                enabled: !!query,
                retry: false,
                ...searchOptions,
            },
        ],
    });
}
